import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { axiosBaseQuery } from "config/axiosBaseQuery";
import {
  ParamsMarcarSolicitudFirmada,
  ParamsRecuperarInfSolicitud,
  ResponseSolicitudFirma,
  ResponseSolicitudFirmaInvitado,
  ResponseSolicitudesFirma,
  SolicitudFirmaBody,
} from "interfaces/solicitudFirma/solicitudFirmaInterface";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost/api/";

export const apiSolicitudFirma = createApi({
  reducerPath: "solicitudFirmaApi",
  baseQuery: axiosBaseQuery({
    baseUrl,
  }),
  endpoints(build) {
    return {
      postSolicitudFirma: build.mutation<ResponseSolicitudFirma, unknown>({
        query: ({ ...args }: SolicitudFirmaBody) => ({
          url: `solicitudes-firmas`,
          method: "POST",
          data: { ...args },
        }),
      }),
      getRecuperarInfSolicitud: build.mutation<ResponseSolicitudFirmaInvitado, unknown>({
        query: ({ llaveFirma }: ParamsRecuperarInfSolicitud) => ({
          url: `solicitudes-firmas/${llaveFirma}`,
          method: "GET",
        }),
      }),
      getObtenerSolicitudesFirma:build.mutation<ResponseSolicitudesFirma , unknown>({
        query:(params:any)=>({
          url:"solicitudes-firmas/de-solicitud-actuacion-demanda",
          method:"GET",
          params
        })
      }),
      putMarcarSolicitudFirmada: build.mutation<ResponseSolicitudFirma, unknown>({
        query: (body: ParamsMarcarSolicitudFirmada) =>({
          url: `solicitudes-firmas/marcar-firmado`,
          method: "put",
          data:body
        }),
      }),
    };
  },
});



export const {
  useGetRecuperarInfSolicitudMutation,
  useGetObtenerSolicitudesFirmaMutation,
  usePostSolicitudFirmaMutation,
  usePutMarcarSolicitudFirmadaMutation,
} = apiSolicitudFirma;
